import Hls from 'hls.js'
import { useEffect, useRef } from 'react'

interface VideoPlayerProps {
  src: string
}
export default function VideoPlayer({ src }: VideoPlayerProps) {
  const videoRef = useRef<null | HTMLVideoElement>(null)

  useEffect(() => {
    const hls = new Hls({
      xhrSetup: function (xhr, url) {},

      loader: Hls.DefaultConfig.loader,
    })

    if (Hls.isSupported() && videoRef.current) {
      hls.loadSource(src)
      hls.attachMedia(videoRef.current)
      hls.on(Hls.Events.ERROR, (err) => {
        console.log(err)
      })
    } else {
      console.log('load')
    }
    return () => {
      // cleanup (when component destroyed or when useEffect runs twice on StrictMode)
      hls.destroy()
    }
  }, [src])

  return (
    <video
      ref={videoRef}
      preload="none"
      autoPlay
      muted
      playsInline
      id="video-player"
    />
  )
}
